import React from "react";
import useStyles from "../AppPageTableContent/styles";
import clsx from "clsx";

export interface Props {
  children?: React.ReactNode;
  className?: string;
  rootRef?: React.RefObject<HTMLDivElement>;
}

const AppPageTableContent = (props: Props) => {
  const { children, className, rootRef } = props;
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.appPageTableContent, className)}
      role="rowgroup"
      ref={rootRef}
    >
      {children}
    </div>
  );
};

export default AppPageTableContent;
